<template>
  <heading tag="h1" icon="library">{{ library.title }}</heading>
  <LbBlockLibraryBook
    :library-book="library.children[0]"
    :title="library.title"
    :subtitle="library.subtitle"
    :content="library.content"
    :media-id="library.children[0].metaIcon"
    :bg-color="library.colorCode"
    :from-profiling="fromProfiling"
  />
</template>
<script lang="ts" setup>
interface Props {
  fromProfiling?: boolean;
}

const props = defineProps({
  fromProfiling: { type: Boolean, default: false }
});

const {
  libraryManager: { library },
} = inject(INJECT_LIBRARY_PAGE_OR_FORM);
</script>
